import { render, staticRenderFns } from "./Campo.vue?vue&type=template&id=61adeea9&lang=pug&"
import script from "./Campo.vue?vue&type=script&lang=js&"
export * from "./Campo.vue?vue&type=script&lang=js&"
import style0 from "./Campo.vue?vue&type=style&index=0&id=61adeea9&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports